const getCategories = () => {};

export default getCategories;
